import actions from './actions'
import mutations from './mutations'

const state = {
  lastSyncDate: null,
  contentSync: false
}

export default {
  state,
  actions,
  mutations
}
